import React, { useEffect, useRef } from 'react';
var VeltReactionTool = function (props) {
    var videoPlayerId = props.videoPlayerId, onReactionToolClick = props.onReactionToolClick;
    var ref = useRef();
    var onReactionToolClickRef = useRef(onReactionToolClick);
    useEffect(function () {
        onReactionToolClickRef.current = onReactionToolClick;
    }, [onReactionToolClick]);
    useEffect(function () {
        var element;
        var handleReactionToolClick = function (event) {
            if (onReactionToolClickRef.current) {
                onReactionToolClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onReactionToolClick', handleReactionToolClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onReactionToolClick', handleReactionToolClick);
            }
        };
    }, []);
    return (React.createElement("velt-reaction-tool", { ref: ref, "video-player-id": videoPlayerId }));
};
export default VeltReactionTool;
